module.exports = __webpack_public_path__ + "img/main_me.812c4ef2.png";